<div class="forms-inputs-group" [ngClass]="{'-single': single, '-multiple': !single}">
    <div class="forms-inputs-group__inner">
        <label class="forms-inputs-group__label" *ngIf="label">{{label}}</label>
        <div class="forms-inputs-group__fields">
            <ng-content></ng-content>
        </div>
    </div>
</div>